<template>
  <BootstrapModal class="EditCategory"
    :class="{editing: category}"
    v-on="$listeners"

    @save="saveCategory"
  >
    <div>
      <FormInput
        class="form-element"
        v-model="$v.name.$model"

        id="name"
        label="Categorie naam"

        :vuelidate="$v"
        fieldName="name"
      />
      <FormTextarea
        class="form-element"
        v-model="$v.description.$model"

        id="descripton"
        label="Beschrijving"

        :vuelidate="$v"
        fieldName="description"
      />
      <SeoFields class="disable-ske"
        :url.sync="$v.seo_url.$model"

        :has-description="false"
        :has-title="false"
      />

      <div v-if="category">
        <h5>Vertalingen</h5>
    
        <CardTabs
          :tabs="tabs"
          v-model="tabState"
          class="card-tabs"
        />
        <div class="border-line"></div>
        <TranslationsManager v-if="tabState === 'translations'" class="mt-3"
          empty-state-title="Dit product heeft geen vertalingen"
          
          :callback="pushCategoryModal"
          :endpoint="endpoint"
          :show-autotranslated="false"
          
          simple-translation-placeholder="Category"
          :simple-translation="true"
        />
        <CategoryProducts v-else-if="tabState === 'category-products'" class="mt-3"
          :category-uid="categoryUid"
        />
        <GenericCrud v-else-if="tabState === 'seo-headlines'"
          v-model="headlines"
          inputPlaceholder="SEO-kop..."

          new-item-message="Nieuwe kop toevoegen."
        />
        <GenericCrud v-else-if="tabState === 'seo-descriptions'"
          v-model="descriptions"
          inputPlaceholder="SEO-beschrijving..."

          new-item-message="SEO-beschrijving toevoegen."
        />
        <GenericCrud v-else-if="tabState === 'seo-keywords'"
          v-model="keywords"
          inputPlaceholder="SEO-zoekwoord..."

          new-item-message="Nieuw zoekwoord toevoegen."
        />
      </div>
    </div>

    <template #title>
      {{
        parent_id
          ? "Subcategorie toevoegen"
          : (category ? "Categorie opslaan" : "Categorie toevoegen")
      }}
    </template>
  </BootstrapModal>
</template>

<script>

import BootstrapModal from "../BootstrapModal.vue"

import FormInput from "src/components/Inputs/FormInput.vue"
import FormTextarea from "../../../components/Inputs/FormTextarea.vue"
import TranslationsManager from "../../TranslationsManager/TranslationsManager.vue"
import CategoryProducts from "../../../components/Category/CategoryProducts.vue"
import CardTabs from "../../CardTabs.vue"
import SeoFields from "../../SeoFields.vue"
import GenericCrud from "../../GenericCrud/GenericCrud.vue"

import { required } from "vuelidate/lib/validators"

export default {
  components: {
    GenericCrud,
    BootstrapModal,
    FormInput,
    TranslationsManager,
    CardTabs,
    CategoryProducts,
    SeoFields,
    FormTextarea,
  },
  props: {
    category: {
      type: Object,
      required: false,
    },
    parent_id: {
      type: String,
      required: false,
    },
    callback: {
      type: Function,
      required: false,
    },
    goBack: {
      type: Function,
      required: false,
    },
  },
  validations: {
    name: {
      required,
    },
    description: {},
    seo_url: {},
  },
  data() {
    return {
      headlines: [],
      descriptions: [],
      keywords: [],
      
      name: "",
      description: "",
      seo_url: "",
      tabState: 'category-products',
    }
  },
  mounted() {
    const cat = this.category
    if (cat) {
      this.$v.name.$model = cat.category
      this.$v.description.$model = cat.description
      this.$v.seo_url.$model = cat.seo_url || []

      this.descriptions = cat.seo_descriptions || []
      this.headlines = cat.seo_headlines || []
      this.keywords = cat.keywords || []
    }
  },
  methods: {
    pushCategoryModal() {
      this.$pushModal({
        modal: "EditCategory",
        toBind: {
          callback: this.callback,
          category: this.category,
          parent_id: this.parent_id,
        },
      })
    },
    saveCategory() {
      this.$v.$touch()
      if (this.$v.$error) return;


      const payload = {
        category: this.$v.name.$model,
        description: this.$v.description.$model,
        seo_url: this.$v.seo_url.$model,
        seo_descriptions: this.descriptions,
        seo_headlines: this.headlines,
        keywords: this.keywords,
      }

      if (this.parent_id) {
        payload.parent_id = this.parent_id
      }
      if (this.category) {
        payload.uid = this.categoryUid
      }


      this.$handlePromise(async () => {
        let message = 'Categorie succesvol toegevoegd!'
        if (!this.category) {
          await this.axios.post(`/api/categories`, payload)
        } else {
          message = 'Categorie succesvol opgeslagen!'
          await this.axios.put(`/api/categories/${this.categoryUid}`, payload)
        }

        this.$success(message)
        this.callback && await this.callback()
        this.$emit("close")
      })
    },
  },
  computed: {
    tabs() {
      return [
        {
          name: "Producten",
          id: "category-products",
        },
        {
          name: "Vertalingen",
          id: "translations",
        },
        {
          name: "SEO Krantenkoppen",
          id: "seo-headlines",
        },
        {
          name: "SEO Beschrijvingen",
          id: "seo-descriptions",
        },
        {
          name: "SEO-zoekwoorden",
          id: "seo-keywords",
        },
      ]
    },
    categoryUid() {
      return this.category && this.category.uid
    },
    endpoint() {
      return `/api/categories/${this.categoryUid}/translations`
    },
  },
}

</script>

<style>

.EditCategory .list-item {
  font-size: 0.875em;
}

</style>

<style scoped>

.EditCategory {
  max-height: 900px;
}

.border-line {
  border-top: 1px solid rgba(0, 0, 0, 0.125);
}

.EditCategory {
  flex-basis: 450px;
}

.editing {
  flex-basis: 1000px;
}

h5 {
  font-size: 1.0625em;
  margin-top: 32px !important;
}

</style>
